import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { FeedFrequencySchema } from './feedOrder.schema';

// ── Base enum ──
export const FeedBaseTypeSchema = z.enum([
  'ONLY_MOM',
  'PREDERED_MOM',
]);
export type FeedBaseType = z.infer<typeof FeedBaseTypeSchema>;

// ── POST /calculate  body ──
export const CalculateFeedSchema = z.object({
  hospital_id:     uuidSchema,
  patient_id:      uuidSchema,
  product_id:      uuidSchema.optional(),
  volume_per_feed: z.number().positive().describe('Volume in mL per feed'),
  feed_frequency:  FeedFrequencySchema.describe('e.g. Every 3h'),
  caloric_density: z.number().positive().describe('kcal/oz or kcal/ml'),
  base:            FeedBaseTypeSchema,
  calculated_by:   uuidSchema,
});
export type CalculateFeed = z.infer<typeof CalculateFeedSchema>;

// ── Single product measure in the response ──
export const FeedMeasureSchema = z.object({
  product_id:          uuidSchema,
  product_name:        z.string(),
  quantity_per_feed:   z.number().describe('ml per single feed'),
  quantity_per_day:    z.number().describe('ml per 24 h'),
  unit:                z.string().default('ml'),
});
export type FeedMeasure = z.infer<typeof FeedMeasureSchema>;

// ── Reservation summary item ──
export const ReservationSummarySchema = z.object({
  reservation_id:     uuidSchema,
  inventory_id:       uuidSchema,
  product_id:         uuidSchema,
  quantity_reserved:  z.string().describe('Decimal as string'),
  quantity_remaining: z.string().describe('Remaining after reservation'),
  unit:               z.string(),
});
export type ReservationSummary = z.infer<typeof ReservationSummarySchema>;

// ── Full calculator response ──
export const CalculateFeedResponseSchema = z.object({
  feeds_per_day:   z.number(),
  volume_per_feed: z.number(),
  total_volume_per_day: z.number(),
  caloric_density: z.number(),
  total_calories_per_day: z.number(),
  base:            FeedBaseTypeSchema,
  measures:        z.array(FeedMeasureSchema),
  reservations:    z.array(ReservationSummarySchema),
});
export type CalculateFeedResponse = z.infer<typeof CalculateFeedResponseSchema>;
